export default {
  name: 'my-team',
  translationKey: 'my-team-module',
  routePrefix: 'my-team',
  routeNamePrefix: 'my-team',
  directRoutesAvailable: true,
}
